import request from './request';

const locations = {
	async getLocations(query) {
		const response = await request.get('/app/locations', query);
		return response;
	},
	async getLocationsByType(query) {
		const response = await request.get('/app/locations/types', query);
		return response;
	}
};

export default locations;